import { Controller } from '@hotwired/stimulus'

// Forces the input value to uppercase as the user types.
export default class extends Controller {
  connect() {
    this.element.addEventListener('input', this.#upcase)
  }

  disconnect() {
    this.element.removeEventListener('input', this.#upcase)
  }

  #upcase = () => {
    this.element.value = (this.element.value || '').toLocaleUpperCase()
  }
}
